// Not all seasons have all colors available, so this function returns a fallback color
// if the requested color is not available for the given season and frame type.
export const getColorFallbackForSeason = (Season, Color, FrameType) => {
  const isSadel = FrameType === "SADEL" || FrameType === "SADEL_BROKEN";

  if (Season === "ISOMAX" && Color === "MATT_BLACK") {
    return isSadel ? "WHITE" : "TEXTURED_BLACK";
  }

  if (Season === "ISOMAX" && Color === "GREY") {
    return "WHITE";
  }

  if (
    (Season === "OPTIMAL" || Season === "ISOLENT") &&
    Color === "TEXTURED_BLACK"
  ) {
    return "MATT_BLACK";
  }

  return undefined;
};
